import { Filter } from "./filter";

type RetrieveZonesIndicatorsFilter = Filter & {
  includeAllZones?: boolean;
};

const retrieveZonesIndicatorsFilter: RetrieveZonesIndicatorsFilter = {};

export type { RetrieveZonesIndicatorsFilter };

export { retrieveZonesIndicatorsFilter };
